export default "__VITE_ASSET__BZ5L_hkw__"